
/* 1. Get data. 2 transform into cache object. 3 update Cache */
import { siteAccessCode } from '../database/apiv2SiteAccessor';
import { InitSensorTypes } from '../Report/Measure/MeterTypes';
import SecondServer from '../database/SecondServer';

export async function checkJobStatus(ss, jobid) {
  const status = await ss.apiData ('/support/ai/status/'+jobid)
  return status
}

export async function pollUntilDone(fetchStatus, { interval = 5000, timeout = 180000 } = {}, signal) {
  const start = Date.now();

  while (!signal.aborted) {
    const result = await fetchStatus();
    if (result?.data?.status === 'COMPLETE'||result?.data?.status === 'FAILED') {
      return result;
    }
    if (Date.now() - start > timeout) {
      throw new Error('Polling timed out');
    }
    if (!signal.aborted)
      await new Promise(resolve => setTimeout(resolve, interval));
  }
}

export async function reqBigConfig (props) {
  const site = props.getActiveSite();
  const siteId = siteAccessCode(site)
  const ss = new SecondServer(props)
  return ss.apiData('/tehama/sites/'+siteId+'/devices/configuration-data?polling=true')
}
export async function getBigConfig (props, ss, cancelPoll) {
  const resp = await reqBigConfig(props)
  const jobid = resp?.data?.jobId
  if (jobid) {
    const result = await pollUntilDone(() => checkJobStatus(ss, jobid), {}, cancelPoll.signal)
    return result?.data?.url
  }
  return undefined
}
export async function readBigConfig (url, cancelSig) {
  let text = ''
  const resp = await fetch(url, {signal: cancelSig.signal})
  if (resp?.body) {
    const decoder = new TextDecoder()
    for await (const chunk of resp?.body) {
      // Each chunk is a Uint8Array (binary data), so chunk.length works
      const textChunk = decoder.decode(chunk);
      text += textChunk
    }
  }
  return JSON.parse(text)
}
export function cacheBigConfig (props, json) {
  const sensorTypes = InitSensorTypes(json?.devices)
  props.updateSiteListCache('site_details', {sensors: sensorTypes, devices: json?.devices})
}
export function siteConfigUpdate (props, deviceId, updObj) {
  // find the right array element, assign the param obj to it
  const site = props.getActiveSite()
  let found = findCachedDevice(site, deviceId)
  console.log (updObj, site)
}
export function addToCache (props, deviceId) {
  const site = props.getActiveSite()
  const found = findCachedDevice(site, deviceId)
  if (!found)
    site.site_details.devices.push({device_id: deviceId})
}
function findCachedDevice (site, deviceId) {
  const udevice = deviceId.toUpperCase()
  return site?.site_details.devices.find(i=>i.device_id.toUpperCase() === udevice)
}
